import { defineStore, getActivePinia } from "pinia";
import useUserDataStore from "@/store/userDataStore.js";
import layoutConfig from "@/config/layoutConfig";
import globalConfig from "@/config/config.js";
import message from "@/components/functionCallComponent/message.jsx";
import apiCommon from "@/api/api/apiCommon.js";
import useModelDataStore from "@/store/model/modelDataStore.js";


const CreateModeClickedStateMap = {
  easy: "click_basic",
  hard: "click_advanced",
  audioRedDot: "show_audio_red_dot",
  "home_vocal": "home_vocal"
}

const useGlobalUserStateStore = defineStore({
  id: "globalUserStateStore",
  state: () => {
    // let datasC = {};
    // try {

    //   datasC = JSON.parse(window.localStorage.getItem(
    //     `${globalConfig.appname}_createUserStateData`
    //   ) ?? "{}");
    // } catch (e) {
    //   datasC = {};
    // }

    // const {
    //   createModeClickedStateVisible,
    //   hasReportedCreateModeClickedState,
    // } = datasC;

    return {
      createModeClickedStateVisible: false,
      hasReportedCreateModeClickedState: false,
      showSongModelClickGuideState: false,
      createModeClickedState: {
        easyMode: false,
        hardMode: false,
      }
    };
  },
  actions: {
    cacheCreateModeClickedState() {
      window.localStorage.setItem(`${globalConfig.appname}_createUserStateData`, {
        createModeClickedStateVisible: this.createModeClickedStateVisible,
        hasReportedCreateModeClickedState: this.hasReportedCreateModeClickedState,
      })
    },
    showBasicModeClickedGuidVisible(type) {
      this.showSongModelClickGuideState = this.setBasicModeClickedGuidVisible(type);
      this.createModeClickedStateVisible = this.showSongModelClickGuideState;
      //this.cacheCreateModeClickedState();
    },
    setBasicModeClickedGuidVisible(type) {
      let showSongModelClickGuideState = false
      if (!this.hasReportedCreateModeClickedState) {
        if (type == "easy") {
          if (!this.createModeClickedState?.easyMode) {
            showSongModelClickGuideState = true;
          } else {
            showSongModelClickGuideState = false;
          }
        } else {
          if (!this.createModeClickedState.hardMode) {
            showSongModelClickGuideState = true;
          } else {
            showSongModelClickGuideState = false;
          }
        }
      } else {
        showSongModelClickGuideState = false;
      }
      this.showSongModelClickGuideState = showSongModelClickGuideState
      return showSongModelClickGuideState;
    },
    queryUserState() {
      return new Promise((resolve, reject) => {
        apiCommon.queryCreateModeState().then((res) => {
          if (res.code == 200) {
            this.createModeClickedState = {
              easyMode: res.data.is_click_basic == true,
              hardMode: res.data.is_click_advanced == true,
            }
            this.hasReportedCreateModeClickedState = res.data?.is_click_basic == true && res.data?.is_click_advanced == true;

            // this.cacheCreateModeClickedState();
            resolve(res.data)

          } else {
            reject(res)
          }
        }).catch((err) => {
          reject(err)
          console.log(err);
        })
      })
    },

    reset() {
      this.createModeClickedStateVisible = false;
      this.hasReportedCreateModeClickedState = false;
      this.showSongModelClickGuideState = false;
      this.createModeClickedState = {
        easyMode: false,
        hardMode: false,
      }
    },


    reportCreateModeClickedState(type) {
      const userDataStore = useUserDataStore();
      const modelDataStore = useModelDataStore();

      // if(this.createModeClickedStateVisible){
      //   setTimeout(() => {
      //     modelDataStore.showChooseModelPop();
      //   },50)
      // }
      if (type == "easy") {
        if (!this.createModeClickedState?.easyMode) {
          this.createModeClickedStateVisible = false;
        }
      } else {
        if (!this.createModeClickedState.hardMode) {
          this.createModeClickedStateVisible = false;
        }
      }
      return new Promise((resolve, reject) => {
        if (!userDataStore.isLogin) {
          reject("用户未登录")
          return
        }
        if (this.hasReportedCreateModeClickedState) {
          reject("已经上报过")
          return
        }
        apiCommon.reportUserState({
          type: CreateModeClickedStateMap[type]
        }).then((res) => {
          if (res.code == 200) {
            switch (type) {
              case "easy":
                this.createModeClickedState.easyMode = true;
                this.showSongModelClickGuideState = false;
                break;
              case "hard":
                this.createModeClickedState.hardMode = true
                this.showSongModelClickGuideState = false
                break;
              default:
                break;
            }
            // this.cacheCreateModeClickedState();
            this.hasReportedCreateModeClickedState = res.data?.is_click_basic == true && res.data?.is_click_advanced == true;
            resolve(res.data)
          } else {
            reject(res)
          }
        }).catch((err) => {
          reject(err)
          console.log(err);
        })
      })
    },
    reportBgmCreateModeClickedState(type) {

    }
  }
});

export default useGlobalUserStateStore;
